import React, { FC } from 'react';
import { DangerDetails } from '@/components/pages/DangerDetails/DangerDetails/DangerDetails';

export const DangerDetailsPage: FC = () => {
  return <DangerDetails />;
};
